import { CarnivoreUser } from '../_types/user.type'

// The Carnivore 33 is Direct Axxess content: every DA member sees it, nobody
// else does. This was briefly behind a per-user `carnivore100` rollout flag on
// top of the tier check; that flag is gone and the tier is the whole gate. The
// backend enforces the same single check (verifyAxxess on the carnivore-100
// route). Kept as a named helper so the three call sites read as intent and
// there is one place to re-gate if the list is ever staged again.
export function hasCarnivore100(user: CarnivoreUser | null | undefined): boolean {
  return !!user?.isAxxess
}
